export function ApprovalsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/approvals.svg'"></ng-include>`
    }
}